import React from 'react';

const data = [
    {
        id: "1",
        avatorImg: "/img/avatar-1.png",
        reviewer: "David K.",
        address: "Regional Sales Manager",
        text: "SalesPinch completely transformed how we manage leads.The role-based workflow ensures clarity and speed across teams.It’s exactly what we needed to boost accountability.",
        icon_1: "fas fa-star",
        icon_2: "fas fa-star",
        icon_3: "fas fa-star",
        icon_4: "fas fa-star",
        icon_5: "far fa-star"
    },
    {
        id: "2",
        avatorImg: "/img/avatar-2.png",
        reviewer: "Jassica William",
        address: "Business Development Manager",
        text: "Since adopting SalesPinch, our lead conversion rate has significantly improved. The AI-powered follow-up suggestions are surprisingly effective. Our sales reps now work smarter, not harder.",
        icon_1: "fas fa-star",
        icon_2: "fas fa-star",
        icon_3: "fas fa-star",
        icon_4: "fas fa-star",
        icon_5: "fas fa-star"
    },
    {
        id: "3",
        avatorImg: "/img/avatar-3.png",
        reviewer: "Johnson Smith",
        address: "Operations Director",
        text: "We love how intuitive and mobile-friendly SalesPinch is. It keeps our field team connected and our managers in control. The dashboards are insightful and tailored to every role.",
        icon_1: "fas fa-star",
        icon_2: "fas fa-star",
        icon_3: "fas fa-star",
        icon_4: "fas fa-star",
        icon_5: "far fa-star"
    }
];

const ReviewSection = () => {
    return (
        <section className="section testimonial-area ptb_100">
            <div className="container text-center">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        <div className="testimonials owl-carousel">
                            {/* Single Testimonial */}
                            {data.map((item, idx) => (
                                <div key={`rt_${idx}`} className="single-testimonial p-3 p-md-5">
                                    <img src={item.avatorImg} className="mx-auto d-block" alt="" />
                                    {/* Client Name */}
                                    <h4 className="client-name mt-4 mb-2">{item.reviewer}</h4>
                                    {/* Client Address */}
                                    <h6 className="client-address fw-4">{item.address}</h6>
                                    {/* Client Rating */}
                                    <div className="client-rating mt-2 mb-3">
                                        <i className={item.icon_1} />
                                        <i className={item.icon_2} />
                                        <i className={item.icon_3} />
                                        <i className={item.icon_4} />
                                        <i className={item.icon_5} />
                                    </div>
                                    {/* Client Description */}
                                    <div className="client-description">
                                        {/* Client Text */}
                                        <div className="client-text">
                                            <p>{item.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReviewSection;